import { api } from "@/lib/api/client";
import type {
  AnalyticalData,
  AnalyticalRange,
  ApiEnvelope,
  ExecutiveData,
  OperationalData,
  Range,
} from "./types";

function unwrap<T>(envelope: ApiEnvelope<T>): T {
  if (!envelope.success) {
    throw new Error(envelope.error || "Error desconocido del servidor");
  }
  return envelope.data;
}

export async function fetchExecutive(range: Range): Promise<ExecutiveData> {
  const { data } = await api.get<ApiEnvelope<ExecutiveData>>(
    "/api/matrix/dashboard/executive",
    { params: { range } },
  );
  return unwrap(data);
}

export async function fetchOperational(): Promise<OperationalData> {
  const { data } = await api.get<ApiEnvelope<OperationalData>>(
    "/api/matrix/dashboard/operational",
  );
  return unwrap(data);
}

export async function fetchAnalytical(range: AnalyticalRange): Promise<AnalyticalData> {
  const { data } = await api.get<ApiEnvelope<AnalyticalData>>(
    "/api/matrix/dashboard/analytical",
    { params: { range } },
  );
  return unwrap(data);
}
